import { ComponentStyle, Datetime, errorMessagesSection, faExclamationCircle, FormStyle,
         infoPlaceholderSection, React} from "@/imports-files/components/custom-datetime";
         import { useState } from 'react';

         import MomentUtils from '@date-io/moment';

         import {
           DatePicker,
           MuiPickersUtilsProvider,
         } from '@material-ui/pickers';

export function CustomDatePicker(props)
{  
      return(
             
        
        <div className= {`CustomDatePicker ${props.className }`} >
           <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                    autoOk
                    variant         =   "inline"
                    inputProps      =   { props.inputProps }
                    minDate         =   { props.minDate}
                    onChange        =   { props.onChange }
                    ref             =   { props.reference }
                    selected        =   { props.selected }
                    format          =   { props.format }
                    value           =   { props.value ? props.value._d || props.value : null} 
                    emptyLabel      =   { props.emptyLabel ? 'Select Date' : ''}
                    disableFuture   =   { props.disableFuture ? props.disableFuture : false}
                    disablePast     =   { props.disablePast ? props.disablePast : false}
                    minDateMessage  =   { props.minDateMessage ? props.minDateMessage : ''}
                    onClose         =    {props.onClose}
                    onOpen          =    {props.onOpen}
                    maxDate         =   { props.maxDate}
                    maxDateMessage  =   { props.maxDateMessage}
                    disabled        =   {props.disabled ? props.disabled : false}
                    />
                    
                    
                </MuiPickersUtilsProvider>

                {
                        props.inputProps.style != undefined ?  errorMessagesSection( props.name, FormStyle, props.formik, props.custom_class || '')
                                                            :  infoPlaceholderSection( props.infoPlaceholder, FormStyle)
                }
            </div>
    
    /* < div className= {ComponentStyle.Datetime__Section}>

                    <Datetime   className       =   {  props.className }
                                closeOnSelect   =   { props.closeOnSelect }
                                dateFormat      =   { props.dateFormat }
                                initialValue    =   { props.initialValue == "Invalid date" ? ''  : props.initialValue }
                                inputProps      =   { props.inputProps }
                                inputValue      =   { props.inputValue }
                                isValidDate     =   { props.isValidDate }
                                onChange        =   { props.onChange }
                                ref             =   { props.reference }
                                selected        =   { props.selected }
                                timeFormat      =   { props.timeFormat }
                                value           =   { props.value ? '' : props.value } 
                    />
                    {
                        props.inputProps.style != undefined ?  errorMessagesSection( props.name, FormStyle, props.formik)
                                                            :  infoPlaceholderSection( props.infoPlaceholder, FormStyle)
                    }
                    
                </div> */
            )
}





